"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.httpService = exports.mailService = exports.authService = exports.Storage = exports.cookieStorage = void 0;
const storage_1 = require("./storage/storage");
const cookie_storage_1 = require("./storage/cookie-storage");
const auth_service_1 = require("./auth/auth-service");
const mail_service_1 = require("./mail/mail-service");
const http_service_1 = require("./http/http-service");
exports.cookieStorage = new cookie_storage_1.CookieStorage();
exports.Storage = new storage_1.LocalStorage();
exports.authService = new auth_service_1.AuthService();
exports.mailService = new mail_service_1.MailService();
exports.httpService = new http_service_1.HttpService();
